// Utility functions for CPF validation
export const formatCPF = (value: string): string => {
  // Remove all non-digits
  const digits = value.replace(/\D/g, '');
  
  // Apply CPF mask: 000.000.000-00
  if (digits.length <= 11) {
    return digits
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2');
  }
  
  return digits.slice(0, 11)
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{2})/, '$1-$2');
};

export const validateCPF = (cpf: string): boolean => {
  // Remove all non-digits
  const digits = cpf.replace(/\D/g, '');
  
  // Check if it has 11 digits
  if (digits.length !== 11) return false;
  
  // Check if all digits are the same
  if (/^(\d)\1{10}$/.test(digits)) return false;
  
  // Validate first check digit
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(digits[i]) * (10 - i);
  }
  let remainder = sum % 11;
  let checkDigit1 = remainder < 2 ? 0 : 11 - remainder;
  
  if (parseInt(digits[9]) !== checkDigit1) return false;
  
  // Validate second check digit
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(digits[i]) * (11 - i);
  }
  remainder = sum % 11;
  let checkDigit2 = remainder < 2 ? 0 : 11 - remainder;
  
  return parseInt(digits[10]) === checkDigit2;
};

export const formatDocument = (value: string, documentType: string): string => {
  if (documentType === 'CPF') {
    return formatCPF(value);
  }
  // For other document types, just remove extra spaces and limit length
  return value.replace(/\s+/g, ' ').trim().slice(0, 50);
};

export const validateDocument = (value: string, documentType: string): boolean => {
  if (documentType === 'CPF') {
    return validateCPF(value);
  }
  // For other document types, just check if it's not empty and has reasonable length
  const cleaned = value.trim();
  return cleaned.length >= 3 && cleaned.length <= 50;
};
